var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHybeMusic = function SvgHybeMusic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "0.5 0.1 192.4 51.5",
    viewBox: "0 0 193 52",
    height: 52,
    width: 193,
    "data-type": "shape",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m122.6 29.4-1.9-6.5h1c.6 2.1 1.3 4.8 1.5 5.6.2-.8 1.2-3.9 1.6-5.6h.9c.4 1.4 1.4 4.7 1.6 5.5.2-1.1 1.2-4.2 1.6-5.5h.9l-2.1 6.5h-1c-.4-1.5-1.4-4.6-1.5-5.4-.2 1-1.1 3.9-1.6 5.4h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.5 26.3H132v2.3h3.9l-.1.7H131v-6.5h4.6v.7H132v2h3.6v.8h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.4 33.8h2.5c1.4 0 2 .7 2 1.6 0 .8-.4 1.2-.9 1.4.5.1 1.1.6 1.1 1.6 0 1.2-.9 1.9-2.2 1.9h-2.6v-6.5h.1zm2.3 2.7c.9 0 1.3-.4 1.3-1s-.4-1-1.2-1h-1.6v2h1.5zm-1.5 3.1h1.6c.8 0 1.4-.4 1.4-1.2 0-.7-.5-1.2-1.5-1.2h-1.4v2.4h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5 37.3h-3.2v2.3h3.5l-.1.7h-4.3v-6.5h4.2v.7h-3.4v2h3.2v.8h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 33.8h.9v5.8h3.4l-.1.7H133v-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 33.8v6.5h-.9v-6.5h.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.8 37.3h-3.2v2.3h3.5l-.1.7h-4.3v-6.5h4.2v.7h-3.4v2h3.2v.8h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.2 40.3-2.4-6.5h.9l1.1 3.2c.3 1 .7 1.9.8 2.5.1-.5.5-1.5.8-2.5l1.2-3.3h.9l-2.4 6.5h-.9v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.7 37.3h-3.2v2.3h3.5l-.1.7h-4.3v-6.5h4.2v.7h-3.4v2h3.2v.8h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.4 33.8v6.5h-.9v-6.5h.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.1 40.3v-6.5h1.1c.9 1.5 3 4.7 3.3 5.5-.1-.8-.1-1.9-.1-2.9v-2.5h.8v6.5h-1.1c-.9-1.4-3-4.9-3.4-5.6v5.6h-.6v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.9 48.5v-3.1c-.3 1.1-1.3 3.8-2.1 5.9h-.8c-.6-1.7-1.6-4.8-1.9-5.9 0 .7.1 2.2.1 3.3v2.6h-.8v-6.5h1.3c.7 2 1.6 4.6 1.9 5.4.2-.6 1.2-3.5 2-5.4h1.2v6.5h-.8v-2.8h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.3 44.7v3.9c0 1.5.8 1.9 1.7 1.9 1 0 1.7-.4 1.7-1.9v-3.9h.9v3.9c0 2.1-1.2 2.7-2.5 2.7-1.4 0-2.5-.7-2.5-2.7v-3.9h.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.4 49.4c.2.8.7 1.2 1.6 1.2 1 0 1.4-.5 1.4-1.1 0-.7-.3-1-1.6-1.3-1.5-.4-2.1-.9-2.1-1.8 0-1 .7-1.8 2.2-1.8 1.5 0 2.2.9 2.3 1.7h-.9c-.1-.6-.5-1.1-1.4-1.1-.8 0-1.2.4-1.2 1s.4.8 1.5 1.1c1.9.5 2.2 1.2 2.2 2 0 1-.8 1.9-2.4 1.9-1.6 0-2.3-.9-2.5-1.9h.9v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.5 44.7v6.5h-.9v-6.5h.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.4 49.4c-.3 1.1-1.1 1.9-2.6 1.9-1.9 0-2.9-1.5-2.9-3.3 0-1.8 1-3.4 3-3.4 1.5 0 2.4.9 2.6 2h-.9c-.2-.7-.7-1.2-1.7-1.2-1.4 0-2 1.3-2 2.6s.6 2.6 2.1 2.6c1 0 1.4-.6 1.7-1.2h.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3.1H.5v51.5h10.8V.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3 24.6H20.7V27h65.6v-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.6.1H95.7v51.5h10.9V.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5 6h-8.1V.4h-2.9v13.9h2.9V8.7h8.1v5.6h3.1V.4h-3.1V6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.5 6.4-4.5-6h-3.4l6.5 8.6v5.4h2.9V9l6.1-8.5H152l-4.5 5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 .5h-12.4v13.8h12.5c.9 0 1.6-.7 1.6-1.6V8.5c0-.8-1-1.1-1-1.1s1-.2 1-1.1V2.1c-.2-.8-.9-1.5-1.7-1.6zm-1.2 2.4v3.3h-8.6V2.9h8.6zm-8.5 9.2V8.5h8.6v3.6h-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.9 2.9V.5h-13.6v13.9h13.6v-2.3H182V8.5h10.9V6.1H182V2.9h10.9z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHybeMusic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hybe-music.88ea7af5.svg";
export { ForwardRef as ReactComponent };